/**
 * Get the display label for an amount field based on the currency
 */
export const getCurrencyAmountLabel = (currency: string): string => {
  switch(currency) {
    case 'XAU':
      return 'Tutar (Altın-Ons)';
    case 'TRY':
      return 'Tutar (TL)';
    case 'USD':
      return 'Tutar ($)';
    case 'EUR':
      return 'Tutar (€)';
    case 'GBP':
      return 'Tutar (£)';
    case 'JPY':
      return 'Tutar (¥)';
    case 'RUB':
      return 'Tutar (₽)';
    case 'KWD':
      return 'Tutar (KWD)';
    case 'SAR':
      return 'Tutar (SAR)';
    case 'CHF':
      return 'Tutar (CHF)';
    case 'BTC':
      return 'Tutar (₿)';
    default:
      return 'Tutar';
  }
};

/**
 * Get the currency symbol based on currency code
 */
export const getCurrencySymbol = (currency: string): string => {
  switch (currency) {
    case "USD": return "$";
    case "EUR": return "€";
    case "GBP": return "£";
    case "JPY": return "¥";
    case "RUB": return "₽";
    case "KWD": return "KWD";
    case "SAR": return "SAR";
    case "CHF": return "CHF";
    case "XAU": return "XAU";
    case "BTC": return "₿";
    case "TRY": default: return "₺";
  }
}; 